@if (easter.state() !== 'idle') {
  <div
    class="ee-overlay"
    [attr.data-state]="easter.state()"
    [attr.data-variant]="easter.currentTier().variant"
  >

    @if (easter.state() === 'armed') {
      <div class="ee-armed" [attr.data-variant]="easter.currentTier().variant">
        <div class="ee-armed__header">
          {{ easter.currentTier().header }}
        </div>
        <div class="ee-armed__bomb" aria-hidden="true">💣</div>
        <div class="ee-armed__countdown">
          <div class="ee-armed__countdown-label">
            {{ easter.currentTier().subtext }}
          </div>
          <div class="ee-armed__countdown-value">{{ easter.countdown() }}</div>
          <div class="ee-armed__countdown-unit">secondi</div>
        </div>
        <div class="ee-armed__bar-wrap">
          <div
            class="ee-armed__bar"
            [style.width.%]="(easter.countdown() / easter.currentTier().duration) * 100"
          ></div>
        </div>
        <button
          type="button"
          class="ee-armed__cancel"
          (click)="easter.cancel()"
        >
          {{ easter.currentTier().cancelLabel }}
        </button>
      </div>
    }

    @if (easter.state() === 'boom') {
      <div class="ee-boom">
        <div class="ee-boom__smoke ee-boom__smoke--1"></div>
        <div class="ee-boom__smoke ee-boom__smoke--2"></div>
        <div class="ee-boom__smoke ee-boom__smoke--3"></div>
        <div class="ee-boom__flash">💥</div>
      </div>
    }

    @if (easter.state() === 'joke') {
      <div class="ee-joke">
        <div class="ee-joke__title">SCHERZONE! 😄</div>
        <div class="ee-joke__subtitle">Il progetto è ancora vivo.</div>
        <div class="ee-joke__hint">…ma il tuo cuore ha battuto per un secondo, ammettilo.</div>
      </div>
    }

    <!--
      SUSPENDED — Tier 4 finale (parte 1).
      Pausa forzata autoironica di 60s. NESSUN blocco reale: l'utente
      può chiudere con "RILASCIA" in qualsiasi momento. Al termine
      del timer transiziona a `secret` per il finale personalizzato.
    -->
    @if (easter.state() === 'suspended') {
      <div class="ee-suspended">
        <div class="ee-suspended__badge">⏸ PAUSA FORZATA</div>
        <div class="ee-suspended__title">
          {{ easter.userName() }} sospeso!
        </div>
        <div class="ee-suspended__subtitle">
          Te l'avevo detto…
        </div>

        <div class="ee-suspended__timer">
          <div class="ee-suspended__timer-value">
            {{ easter.suspendedCountdown() }}
          </div>
          <div class="ee-suspended__timer-unit">secondi rimanenti</div>
        </div>

        <div class="ee-suspended__advice">
          ☕ Prenditi un tè.
        </div>
        <div class="ee-suspended__hint">
          Stai tranquillo, nessun ordine è stato danneggiato in questo scherzone.
        </div>

        <button
          type="button"
          class="ee-suspended__release"
          (click)="easter.cancel()"
        >
          OK, ho capito la lezione — RILASCIA
        </button>
      </div>
    }

    <!--
      SECRET — Tier 4 finale (parte 2).
      GIF + messaggio personale del maintainer come "reward" del
      percorso completo. Auto-close 10s, chiudibile con X o click
      backdrop.
    -->
    @if (easter.state() === 'secret') {
      <div class="ee-secret" (click)="$event.stopPropagation()">
        @if (easter.gifPath()) {
          <img [src]="easter.gifPath()" alt="" class="ee-secret__gif" />
        }
        <div class="ee-secret__message">{{ easter.personalMessage() }}</div>
        <button
          type="button"
          class="ee-secret__close"
          (click)="easter.cancel()"
          aria-label="Chiudi"
        >
          ✕
        </button>
      </div>
    }

  </div>
}
